import React, { useState } from "react"
import { Fab, Dialog, Table, Typography, TableBody, Box, TableCell, TableContainer, TableRow, TableHead, Paper, IconButton } from "@mui/material"
import { Add as AddIcon, Close as CloseIcon } from '@mui/icons-material'

import AddFridgeItem from "./AddFridgeItem"
import BiestFridgeCell from "./BiestFridgeCell"

export default function BiestFridgeTable({ biestList, setBiestList, selectedFarmer, setFridgeOpen }) {

    const [openItemAdder, setOpenItemAdder] = useState(false)

    const farmerList = biestList.filter((biest) => biest.boerEmail === selectedFarmer)
    const fridgeList = farmerList.filter((biest) => (biest.kalfId.length === 0 && !biest.scrapped))

    return (
        <>
            <Paper sx={{ overflow: 'hidden' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
                    <Typography variant="button" sx={{ mt: 1 }} display="flex" justifyContent="center">
                        biestvoorraad
                    </Typography>
                    <IconButton sx={{ color: 'black' }} onClick={() => setFridgeOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <TableContainer sx={{ maxHeight: 400 }}>
                    <Table stickyHeader size='medium' aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Koe</TableCell>
                                <TableCell align="right">Datum</TableCell>
                                <TableCell align="right">Brix %</TableCell>
                                <TableCell align="right">Volume</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fridgeList.map((biestSample) => 
                                <BiestFridgeCell key={biestSample.id} biestSample={biestSample} setBiestList={setBiestList} />
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box display='flex' justifyContent='center'>
                    <Fab variant="extended" onClick={() => setOpenItemAdder(true)} size="medium" color="primary" sx={{ m: 2 }}>
                        <AddIcon sx={{ mr: 1 }} />
                        Biest toevoegen
                    </Fab>
                </Box>
            </Paper>
            <Dialog fullWidth sx={{ padding: '10px' }} open={openItemAdder} onClose={() => setOpenItemAdder(false)}>
                <AddFridgeItem setOpenItemAdder={setOpenItemAdder} setBiestList={setBiestList} selectedFarmer={selectedFarmer} />
            </Dialog>
        </>
    )
}
